"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createSimplifiedCacheKey = void 0;
var _constants = require("../constants");
var _isEmptyObject = require("./isEmptyObject");
var createSimplifiedCacheKey = function(options) {
    if (!options) {
        return null;
    }
    var url = options.url, query = options.query, headers = options.headers, variables = options.variables;
    var headersForCacheKey = _object_spread({}, headers);
    if (Object.hasOwn(headersForCacheKey, _constants.AUTHORIZATION)) {
        delete headersForCacheKey[_constants.AUTHORIZATION]; // We do not wan't to store token in cache as it differs on server and client.
    }
    // Return a cache key object with non-empty properties
    var cacheKey = _object_spread({}, url && {
        url: url
    }, query && {
        query: query
    }, variables && !(0, _isEmptyObject.isEmptyObject)(variables) && {
        variables: variables
    }, headers && !(0, _isEmptyObject.isEmptyObject)(headersForCacheKey) && {
        headers: headersForCacheKey
    });
    return cacheKey;
};
exports.createSimplifiedCacheKey = createSimplifiedCacheKey; //# sourceMappingURL=createSimplifiedCacheKey.js.map
